import { render, staticRenderFns } from "./AppSiteFooter.vue?vue&type=template&id=58bad590&scoped=true&"
import script from "./AppSiteFooter.vue?vue&type=script&lang=js&"
export * from "./AppSiteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bad590",
  null
  
)

export default component.exports